<template>
  <div id="modal-share" class="mbsc-cloak modal-share">
    <a class="btn-dismiss" @click="btndismiss"><i class="fa-times"></i></a>
    <div class="modal-body" v-if="codeaffiliate.agent == '1'">
      <h2 class="topic">ลิงก์สำหรับตัวแทน</h2>
      <input type="text" id="copy-text" class="copy-text" :value="urlshare.url_affiliate" readonly />
      <button
        @click="copybutton()"
        class="btn--success copy-text copy-button"
        data-clipboard-action="copy"
        data-clipboard-target="#copy-text"
      >
        คลิกเพื่อคัดลอกลิงก์
      </button>
      <h5 class="copy-status" id="copy-status">คัดลอกแล้ว</h5>
    </div>
    <hr v-if="codeaffiliate.agent == '1'" />
    <h2 class="topic">แชร์ไปยัง</h2>
    <div class="btn-social">
      <a class="btn btn--facebook" target="_blank" :href="urlshare.url_facebook">
        <i class="fab fa-facebook-square"></i> Facebook
      </a>
      <a class="btn btn--line" target="_blank" :href="urlshare.url_line">
        <i class="fa-line" aria-hidden="true"></i> Line
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { setTimeout } from 'timers'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['urlshare','codeaffiliate'])
  },
  methods: {
    btndismiss() {
      showAccount.hide()
    },
    copybutton() {
      //alert("ssss");
      new Clipboard('.copy-text')

      $('#copy-status').show()

      $('.copy-text').addClass('copied')

      setTimeout(function() {
        $('#copy-status').hide()
        $('.copy-text').removeClass('copied')
      }, 2000)
    }
  },
  mounted() {
    //console.log(this.codeaffiliate)
  }
}
</script>

<style>
</style>